import type { ConsoleUser } from "../context/AuthContext";

/** Matches server `INVENTORY_STORE_SCOPED_PERMISSION_KEYS` — inventory data is filtered by assigned yards when set on the user. */
export const INVENTORY_STORE_SCOPED_PERMISSION_KEYS = [
  "inventory_inward",
  "inventory_outward",
  "inventory_store_stocks",
  "inventory_goods_receipts",
  "inventory_issue_po",
  "inventory_issue_material",
] as const;

export function permRecordNeedsInventoryStoreChoice(perm: Record<string, boolean>): boolean {
  return INVENTORY_STORE_SCOPED_PERMISSION_KEYS.some((k) => Boolean(perm[k]));
}

export function filterStoreYardsByConsoleScope<T extends { id: string }>(
  yards: T[],
  user: ConsoleUser | null,
  authRequired: boolean,
): T[] {
  if (!authRequired || !user || user.role === "superadmin") return yards;
  const scoped = user.inventoryStoreYardIds;
  if (!Array.isArray(scoped) || scoped.length === 0) return yards;
  const allow = new Set(scoped);
  return yards.filter((y) => allow.has(y.id));
}
